import Loadable from "react-loadable";

export const AddPitchButton = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.AddPitchButton) as Promise<any>,
  loading: () => null,
});
